<div class="inventory-assignment">
  <div class="cards">
    <div class="card">
      <div class="form-group">
        <select class="form-control" (change)="changeFieldGroup($event)" id="selectAssignment">
          <option value="" selected>Inventory Tools</option>
        </select>
      </div>
    </div>
    <div class="card">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label>Inventory Notes</label>
            <textarea
              class="form-control"
              [(ngModel)]="notes"
              rows="5"
              placeholder="Add notes to give context to inventory"
              (keyup)="addTransferNotes($event)"></textarea>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label>Inventory Date</label>
            <input
              class="form-control datepicker"
              type="date"
              [(ngModel)]="inventoriedDate"
              [min]="previousDate()"
              (change)="handleInventoryDate($event)"
              required />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <button class="btn btn-primary" (click)="handleMarkToolsAsInventoried('transfer')">Inventory & Transfer</button>
    <button class="btn btn-outline-primary" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="handleMarkToolsAsInventoried()">Inventory</button>
    <button class="btn btn-primary" (click)="handleMarkToolsAsInventoried('close')">Inventory & Close</button>
  </div>
</div>
